import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  createPersonalProfilerAction,
  getAllCompanyProprietorsAction,
  getPersonalProfilerAction,
  patchPersonalProfilerAction,
} from '../action';
import { toast, ToastContainer } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import { OperationType } from '../../../utils/settings';

function RecreationDetails({ expanded = false }) {
  const [recreationDetailsList, setRecreationDetailsList] = useState([]);
  const [recreationDetails, setRecreationDetails] = useState({});
  const [ownersList, setOwnersList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isAddingDestination, setIsAddingDestination] = useState(false);
  const [proprietorsList, setProprietorsList] = useState([
    {
      firm_info: {},
      proprietors_list: [],
    },
  ]);
  const [proprietorsFlatList, setProprietorsFlatList] = useState([]);

  useEffect(() => {
    const flatProprietorsList = Array.from(
      new Set(
        proprietorsList.flatMap((item) =>
          item.proprietors_list.map((prop) => JSON.stringify(prop)),
        ),
      ),
    ).map((str) => JSON.parse(str));

    setProprietorsFlatList(flatProprietorsList);
  }, [proprietorsList]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setRecreationDetails({});
    setIsAddingDestination(false);
    setIsEditing();
  };

  const getPersonalProfiler = async () => {
    const { data, error, message } = await getPersonalProfilerAction();

    if (!error) setRecreationDetailsList(data.recreation_details_info);
    else toast.error(message);
  };

  const getProprietorsList = async () => {
    const { data, error, message } = await getAllCompanyProprietorsAction();

    if (!error) setProprietorsList(data);
    else toast.error(message);
  };

  useEffect(() => {
    if (expanded) {
      getPersonalProfiler();
      getProprietorsList();
    }
  }, [expanded]);

  const onFinish = async () => {
    if(!recreationDetails.firmDetails) return toast.error('Please Select Firm');
    if(!recreationDetails.ownerDetails) return toast.error('Please Select Owner');
    if(!recreationDetails.country_name) return toast.error('Please Enter Country Name');
    if(!recreationDetails.location_name) return toast.error('Please Enter Location Name');

    const recreationPayload = {
      firm_id: recreationDetails.firmDetails.id,
      owner_id: recreationDetails.ownerDetails.id,
      recreational_list: [
        {
          country_name: recreationDetails.country_name,
          location_name: recreationDetails.location_name,
          is_international: recreationDetails.is_international,
        },
      ],
    };

    const finalPayload = {
      personal_details_info: [],
      family_details_info: [],
      recreation_details_info: [recreationPayload],
    };

    const { error, message } = await createPersonalProfilerAction(finalPayload);

    if (!error) {
      toast.success(message);
      handleClose();
      getPersonalProfiler();
    } else {
      toast.error(message);
    }
  };

  const onEdit = (item, obj) => {
    const { firm_info, owner_info } = obj;

    const payload = {
      firmDetails: firm_info,
      ownerDetails: owner_info,
      country_name: item.country_name,
      location_name: item.location_name,
      is_international: item.is_international,
      id: item.id,
    };

    const value = firm_info.id;
    const found = proprietorsList.find((item) => item.firm_info.id === value);
    setOwnersList(found.proprietors_list);

    setRecreationDetails(payload);
    setIsEditing(true);
    handleOpen();
  };

  const onUpdate = async () => {
    if(!recreationDetails.firmDetails) return toast.error('Please Select Firm');
    if(!recreationDetails.ownerDetails) return toast.error('Please Select Owner');
    if(!recreationDetails.country_name) return toast.error('Please Enter Country Name');
    if(!recreationDetails.location_name) return toast.error('Please Enter Location Name');

    const payload = {
      recreational_details_info: [
        {
          firm_id: recreationDetails.firmDetails.id,
          owner_id: recreationDetails.ownerDetails.id,
          recreation_details_info: [
            {
              id: recreationDetails.id,
              operation_type: OperationType['UPDATE'],
              country_name: recreationDetails.country_name,
              location_name: recreationDetails.location_name,
              is_international: recreationDetails.is_international,
            },
          ],
        },
      ],
    };

    const { error, message } = await patchPersonalProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getPersonalProfiler();
    } else {
      toast.error(message);
    }
  };

  const onAddDestination = (data) => {
    const { firm_info, owner_info } = data;

    const payload = {
      firmDetails: firm_info,
      ownerDetails: owner_info,
    };

    const value = firm_info.id;
    const found = proprietorsList.find((item) => item.firm_info.id === value);
    setOwnersList(found.proprietors_list);

    setRecreationDetails(payload);
    setIsAddingDestination(true);
    handleOpen();
  };

  const onAddDestinationFinish = async () => {
    const payload = {
      recreational_details_info: [
        {
          firm_id: recreationDetails.firmDetails.id,
          owner_id: recreationDetails.ownerDetails.id,
          recreation_details_info: [
            {
              operation_type: OperationType['ADD'],
              country_name: recreationDetails.country_name,
              location_name: recreationDetails.location_name,
              is_international: recreationDetails.is_international,
            },
          ],
        },
      ],
    };

    const { error, message } = await patchPersonalProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getPersonalProfiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className="custom-toast-container" />
      <CardContent>
        {recreationDetailsList.map((item) => (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1-content'
              id='panel1-header'
              sx={{
                padding: 1,
                paddingLeft: 2,
                paddingRight: 2,
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}>
                {/* <div className='pro-vertical-block' /> */}

                <Typography fontWeight={'600'}>
                  {item.owner_info.name} | {item.firm_info.name}
                </Typography>

                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    onAddDestination(item);
                  }}
                  variant='outlined'
                  style={{
                    marginRight: 10,
                  }}>
                  <Typography>Add Destination</Typography>
                </Button>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '20px',
                }}>
                {item.recreational_info.map((vv) => (
                  <Box
                    sx={{
                      borderWidth: 2,
                      borderColor: '#F59C1E',
                      borderStyle: 'solid',
                      padding: 2,
                      borderRadius: 2,
                      marginBottom: 3,
                    }}>
                    <div
                      className='row-center'
                      style={{
                        justifyContent: 'space-between',
                        marginBottom: 5,
                        position: 'relative',
                      }}>
                      <div
                        className='editCtr'
                        style={{ position: 'absolute', right: -30, top: -35 }}
                        onClick={() => onEdit(vv, item)}>
                        <Tooltip title='Edit Details'>
                          <EditIcon color='primary' />
                        </Tooltip>
                      </div>
                      <div className='row-center'>
                        <Typography
                          fontSize={15}
                          fontWeight={'600'}
                          sx={{ marginRight: 1 }}>
                          {vv.country_name}
                        </Typography>
                        |
                        <Typography
                          fontSize={15}
                          fontWeight={'600'}
                          sx={{ marginLeft: 1 }}>
                          {vv.location_name}
                        </Typography>
                      </div>
                    </div>
                    <div
                      className='row-center'
                      style={{
                        // justifyContent: 'flex-end',
                        marginBottom: 5,
                        alignItems: 'center',
                      }}>
                      <div
                        className='row-center'
                        style={{ marginRight: 10 }}>
                        <div className='row-center'>
                          <Typography
                            fontSize={15}
                            sx={{ marginRight: 1 }}>
                            Is International?
                          </Typography>
                        </div>
                        -
                        <div className='row-center'>
                          <Typography
                            fontSize={15}
                            sx={{ marginLeft: 1 }}>
                            {vv.is_international ? 'Yes' : 'No'}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </Box>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        ))}
      </CardContent>

      <div
        className='row-center'
        style={{
          justifyContent: 'flex-end',
        }}>
        <div>
          <Button
            onClick={() => {
              if (proprietorsFlatList.length === 0)
                return toast.error('Please add owners and then fill details');
              handleOpen();
            }}
            sx={{ width: 150 }}
            variant='contained'>
            Add
          </Button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={{
            backgroundColor: 'white',
            width: '50%',
            overflowY: 'scroll',
            maxHeight: '90vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}>
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}>
                {' '}
                {isEditing
                  ? 'Update Recreation Details'
                  : 'Add Recreation Details'}
              </Typography>
            </div>
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Select Firm
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  disabled={isEditing || isAddingDestination}
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Firm
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={recreationDetails?.firmDetails?.id}
                    label='Select Firm'
                    onChange={(e) => {
                      const value = e.target.value;
                      const found = proprietorsList.find(
                        (item) => item.firm_info.id === value,
                      );

                      setRecreationDetails((prev) => ({
                        ...prev,
                        firmDetails: found.firm_info,
                      }));
                      setOwnersList(found.proprietors_list);
                    }}>
                    {proprietorsList.map((item) => (
                      <MenuItem value={item.firm_info.id}>
                        {item.firm_info.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Select Owner
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  disabled={isEditing || isAddingDestination}
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Owner
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={recreationDetails?.ownerDetails?.id}
                    label='Select Owner'
                    onChange={(e) => {
                      const value = e.target.value;
                      const found = ownersList.find(
                        (item) => item.id === value,
                      );
                      setRecreationDetails((prev) => ({
                        ...prev,
                        ownerDetails: found,
                      }));
                    }}>
                    {ownersList.map((item) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Country Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Country Name'
                  name='country_name'
                  value={recreationDetails?.country_name}
                  onChange={(e) => {
                    setRecreationDetails((prev) => ({
                      ...prev,
                      country_name: e.target.value,
                    }));
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Location Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='location Name'
                  name='location_name'
                  value={recreationDetails?.location_name}
                  onChange={(e) => {
                    setRecreationDetails((prev) => ({
                      ...prev,
                      location_name: e.target.value,
                    }));
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Is It International
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Is International
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={recreationDetails?.is_international}
                    label='Is International'
                    onChange={(e) => {
                      const value = e.target.value;
                      setRecreationDetails((prev) => ({
                        ...prev,
                        is_international: value,
                      }));
                    }}>
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div
              className='row-center'
              style={{
                justifyContent: 'flex-end',
              }}>
              <div>
                {/*  */}
                <Button
                  onClick={handleClose}
                  sx={{ width: 150, marginTop: 2, marginRight: 2 }}
                  variant='contained'
                  color='error'>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (isAddingDestination) onAddDestinationFinish();
                    else if (isEditing) onUpdate();
                    else onFinish();
                  }}
                  sx={{ width: 150, marginTop: 2 }}
                  variant='contained'>
                  Save
                </Button>
              </div>
            </div>
          </CardContent>
        </Box>
      </Modal>
    </div>
  );
}

export default RecreationDetails;
